import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { NextActionItemContentDirective } from '../../sub-directives/next-action-item-content.directive';
import { NextActionItemContentAttentionDirective } from '../../sub-directives/next-action-item-content-attention.directive';

@Component({
  selector: 'asw-next-action-item',
  templateUrl: './next-action-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NextActionItemComponent implements OnInit {
  @ViewChild('template', { static: true })
  template!: TemplateRef<unknown>;
  @ViewChild('templateCanBeClicked', { static: true })
  templateCanBeClicked!: TemplateRef<unknown>;
  @ViewChild('templateCantBeClicked', { static: true })
  templateCantBeClicked!: TemplateRef<unknown>;

  displayedTemplate!: TemplateRef<unknown>;

  @ContentChildren(NextActionItemContentDirective)
  contentList!: QueryList<NextActionItemContentDirective>;
  @ContentChildren(NextActionItemContentAttentionDirective)
  contentAttentionList!: QueryList<NextActionItemContentAttentionDirective>;

  @Input() set canBeClicked(canBeClicked: boolean) {
    this.displayedTemplate = canBeClicked ? this.templateCanBeClicked : this.templateCantBeClicked;
  }
  @Input() title = '';
  @Input() titleAria = '';
  @Input() textContent = '';
  @Input() itemId = '';

  @Output() clickNextAction = new EventEmitter();

  viewContainerRef = inject(ViewContainerRef);

  get hasContentList() {
    return Boolean(this.contentList?.length);
  }

  get hasContentAttentionList() {
    return Boolean(this.contentAttentionList?.length);
  }

  ngOnInit(): void {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  onClick() {
    this.clickNextAction.emit();
  }
}
